import React from "react"
import { ConsentProvider } from "./ConsentContext"
import ConsentBanner from "./ConsentBanner"
import ConsentLoader from "./ConsentLoader"

export { useConsent, useConsentGranted } from "./useConsent"
export { ConsentProvider }

type WrapProps = {
  children: React.ReactNode
}

export const ConsentGateProvider: React.FC<WrapProps> = ({ children }) => {
  return (
    <ConsentProvider>
      <ConsentLoader />
      {children}
      <ConsentBanner />
    </ConsentProvider>
  )
}

export default ConsentGateProvider
